export const ApplyForumArr = [
  {
    path: "forum/:id",
    name: "forum/:id",
    redirect: "/apply/forum/:id/forumHome",
    meta: {
      title: "论坛"
    },
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "forumHome",
        name: "forumHome",
        meta: {
          title: "论坛首页"
        },
        component: () => import("@/views/apply/forum/forumHome.vue")
      },
      {
        path: "forumList",
        name: "forumList",
        meta: {
          title: "论坛列表"
        },
        component: () => import("@/views/apply/forum/forumList.vue")
      },
      {
        path: "userList",
        name: "userList",
        meta: {
          title: "用户列表"
        },
        component: () => import("@/views/apply/forum/userList.vue")
      },
      {
        path: "addPosts",
        name: "addPosts",
        meta: {
          title: "发布帖子"
        },
        component: () => import("@/views/apply/forum/components/addPosts.vue")
      },
      {
        path: "blacklist",
        name: "blacklist",
        meta: {
          title: "黑名单"
        },
        component: () => import("@/views/apply/forum/blacklist.vue")
      },
      {
        path: "lanternSlide",
        name: "lanternSlide",
        meta: {
          title: "幻灯片"
        },
        component: () => import("@/views/apply/forum/lanternSlide.vue")
      },
      {
        path: "addSlice",
        name: "addSlice",
        meta: {
          title: "添加幻灯片"
        },
        component: () => import("@/views/apply/forum/components/addSlice.vue")
      },
      {
        path: "basicsSetting",
        name: "basicsSetting",
        meta: {
          title: "基础设置"
        },
        component: () => import("@/views/apply/forum/basicsSetting.vue")
      },
      {
        path: "classList",
        name: "classList",
        meta: {
          title: "分类列表"
        },
        component: () => import("@/views/apply/forum/classList.vue")
      },
      {
        path: "comment",
        name: "comment",
        meta: {
          title: "评论管理"
        },
        component: () => import("@/views/apply/forum/comment.vue")
      },
      {
        path: "search",
        name: "search",
        meta: {
          title: "搜索设置"
        },
        component: () => import("@/views/apply/forum/search.vue")
      },
      // 公告管理
      {
        path: "announcement",
        name: "announcement",
        meta: {
          title: "公告管理"
        },
        component: () => import("@/views/apply/forum/announcement/index.vue")
      },
      // 广告管理
      {
        path: "advertisement",
        name: "advertisement",
        meta: {
          title: "广告管理"
        },
        component: () => import("@/views/apply/forum/advertisement/index.vue")
      },
      {
        path: "report",
        name: "report",
        meta: {
          title: "帖子举报"
        },
        component: () => import("@/views/apply/forum/report.vue")
      },
      {
        path: "homeRecommend",
        name: "homeRecommend",
        meta: {
          title: "首页推荐"
        },
        component: () => import("@/views/apply/forum/homeRecommend.vue")
      },
      {
        path: "sensitiveFilter",
        name: "sensitiveFilter",
        meta: {
          title: "敏感词过滤"
        },
        component: () => import("@/views/apply/forum/sensitiveFilter.vue")
      },
      {
        path: "adadvertisement",
        name: "adadvertisement",
        meta: {
          title: "添加广告"
        },
        component: () =>
          import("@/views/apply/forum/advertisement/adAdvertisement.vue")
      }
    ]
  }
];
